import { selector } from 'lib/selectors';

const notifications = (state) => state.notifications;
export const getNotificationsSelector = selector(notifications, (x) => x.data);
export const getNotificationsIsLoadingSelector = selector(notifications, (x) => x.isLoading);
